import React, { FC } from 'react'
import './Contactos.scss'
import { IoClose } from 'react-icons/io5'

const mailIcon = require('app_assets/images/icons/mail.png')

interface IContactosProps {
  buttonClose: () => void
}

const Contactos: FC<IContactosProps> = ({ buttonClose }) => {
  return (
    <div className='contactos-large-container'>
      <IoClose onClick={buttonClose} className='contactos--close-icon'/>
      <div className='contactos-title'>Contáctanos</div>
      <p style={{fontSize: 18, color: 'var(--text3)'}}>Si necesitas más información comunícate con nuestras líneas de atención en cada país:</p>
      <div className='contactos-container'>
        <div className='contactos-numbers'>
          <p><strong>Bolivia:</strong> (591) 22153054</p>
          <p><strong>Guatemala:</strong> (503) 35668988</p>
          <p><strong>Colombia:</strong> #426 ó 018000949000</p>
          <p><strong>Honduras:</strong> (504) 2270-7039</p>
          <p><strong>Chile:</strong> (569) 46220058</p>
          <p><strong>México:</strong> (55)-41610086</p>
          <p><strong>Ecuador:</strong> (593 2) 6014679</p>
          <p><strong>Peru:</strong> (51) 976059801</p>
          <p><strong>El Salvador:</strong> (503) 22895712</p>
        </div>
        <div className='contactos--main-container'>
          <p style={{fontSize: 18, color: 'var(--text3)'}}>O cliquea aquí para enviarnos un correo</p>
          <a href='mailto:cliente@icontec.org'>
            <div className='contactos--mail-box'>
              <img src={mailIcon} alt='mail' className='contactos-mail-image'/>
                <p style={{textDecoration: 'underline'}}>cliente@icontec.org</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Contactos
